var h = 2147483647, l = (t) => t.nodeType === Node.DOCUMENT_NODE, g = (t) => t != null && t === t.window;
function m(t) {
  return l(t) ? t : g(t) ? t.document : (t == null ? void 0 : t.ownerDocument) ?? document;
}
var s = () => typeof document < "u";
function v() {
  const t = navigator.userAgentData;
  return (t == null ? void 0 : t.platform) ?? navigator.platform;
}
var p = (t) => s() && t.test(v()), y = (t) => s() && t.test(navigator.vendor), N = () => b() && y(/apple/i), b = () => p(/mac|iphone|ipad|ipod/i), a = (t) => typeof t == "object" && t !== null && t.nodeType === 1, A = (t) => a(t) && t.tagName === "IFRAME";
function D(t) {
  return a(t) ? t.offsetWidth > 0 || t.offsetHeight > 0 || t.getClientRects().length > 0 : !1;
}
var c = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false']), details > summary:first-of-type", E = (t, n = !1) => {
  if (!t) return [];
  const e = Array.from(t.querySelectorAll(c));
  (n == !0 || n == "if-empty" && e.length === 0) && a(t) && u(t) && e.unshift(t);
  const r = e.filter(u);
  return r.forEach((i, f) => {
    if (A(i) && i.contentDocument) {
      const d = i.contentDocument.body;
      r.splice(f, 1, ...E(d));
    }
  }), r;
};
function u(t) {
  return !t || t.closest("[inert]") ? !1 : t.matches(c) && D(t);
}
function S(t, n) {
  return Array.from((t == null ? void 0 : t.querySelectorAll(n)) ?? []);
}
function w(t, n) {
  return (t == null ? void 0 : t.querySelector(n)) ?? null;
}
function R(t) {
  const n = {
    getRootNode: (e) => {
      var o;
      return ((o = e.getRootNode) == null ? void 0 : o.call(e)) ?? document;
    },
    getDoc: (e) => m(n.getRootNode(e)),
    getWin: (e) => n.getDoc(e).defaultView ?? window,
    getActiveElement: (e) => n.getRootNode(e).activeElement,
    isActiveElement: (e, o) => o === n.getActiveElement(e),
    getById: (e, o) => n.getRootNode(e).getElementById(o),
    setValue: (e, o) => {
      if (e == null || o == null) return;
      const r = o.toString();
      e.value !== r && (e.value = o.toString());
    }
  };
  return { ...n, ...t };
}
export {
  h as MAX_Z_INDEX,
  R as createScope,
  m as getDocument,
  E as getFocusables,
  v as getPlatform,
  b as isApple,
  l as isDocument,
  s as isDom,
  u as isFocusable,
  N as isSafari,
  g as isWindow,
  w as query,
  S as queryAll
};
